import { render, staticRenderFns } from "./Transferencia-fondos.vue?vue&type=template&id=4220e35a"
import script from "./Transferencia-fondos.vue?vue&type=script&lang=js"
export * from "./Transferencia-fondos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports